<template>
  <div class="sw-modal confirm-dialog">
    <div v-click-outside="cancelAction" class="sw-modal-content">
      <div class="row sw-modal-heading">
        <div class="col">
          <h4>Select Files</h4>
        </div>
      </div>
      <div class="sw-modal-body">
        <div class="row">
          <div class="col-12">
            <template v-if="hasFiles">
              <div v-for="(file, index) in copyOfFiles"
                   v-bind:key="index"
                   class="edit-establishment__images-thumbnail edit-establishment__images-thumbnail--file"
                   v-on:click.stop="select(file.reference)"
              >
                <img v-if="isImage(file)" v-bind:src="file.url"/>
                <div v-else class="edit-establishment__images-thumbnail__doc">
                  <i class="fas fa-file-image"></i>
                </div>
                <div v-if="!isImage(file)" class="edit-establishment__images-thumbnail-filename">
                  <div>{{getFilename(file)}}</div>
                </div>
                <div v-if="file.selected" class="file-selector__file--selected">
                  <i class="fas fa-paperclip"></i>
                </div>
              </div>
            </template>
            <template v-else>
              <p>You have not uploaded any files to choose from.</p>
              <p>Please upload files first by going to
                <b>Configure Establishments > Files</b> under your profile name.</p>
            </template>
          </div>
        </div>
        <div class="sw-modal-actions">
          <div class="row">
            <div class="col text-center">
              <button class="btn btn-normal" v-on:click.stop="cancelAction()">Cancel</button>
              <button v-if="hasFiles" class="btn btn-primary" v-on:click.stop="selectAction()">Select</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'FileSelectorDialog',
        components: {
        },
        props: {
            files: Array,
        },
        data: function() {
            return {
                copyOfFiles: []
            }
        },
        computed: {
            hasFiles: function() {
                return this.copyOfFiles.length > 0;
            }
        },
        methods: {
            isImage: function(file) {
                if (file.type && file.type.startsWith('image')) {
                    return true;
                } else {
                    return false;
                }
            },
            getFilename: function(file) {
                if (file.url) {
                    if (file.url.indexOf('/') > 0) {
                        return file.url.substr(file.url.lastIndexOf('/') + 1);
                    }
                    return file.url;
                }
                return '';
            },
            select: function(reference) {
                for (let i = 0; i < this.copyOfFiles.length; i++) {
                    if (this.copyOfFiles[i].reference === reference) {
                        if (this.copyOfFiles[i].selected) {
                            Vue.set(this.copyOfFiles[i], 'selected', false);
                        } else {
                            Vue.set(this.copyOfFiles[i], 'selected', true);
                        }
                        break;
                    }
                }
            },
            cancelAction: function() {
                this.$root.$emit("finished-selecting-files");
            },
            selectAction: function() {
                let selectedFiles = [];
                for (let file of this.copyOfFiles) {
                    if (file.selected) {
                        selectedFiles.push(file);
                        Vue.set(file, 'selected', false);
                    }
                }
                this.$root.$emit("finished-selecting-files", selectedFiles);
            },
        },
        mounted() {
            this.copyOfFiles = [...this.files];
        }
    }
</script>

<style lang="scss" scoped>
  @import "../../styles/components/modal.scss";
  @import "../../styles/components/edit_establishment";
  @import "../../styles/components/file_selector_dialog.scss";
</style>